<i *ngIf="icon"
   class="icon"
   [class.material-icons]="selected"
   [class.material-icons-outlined]="!selected">
  {{icon}}
</i>
<span class="text">
  <ng-content></ng-content>
</span>
